<template>
  <span v-show="isLegacyOrder">
    <base-button
      size="sm"
      :disabled="isReadOnly || isPartnerAccount"
      :class="'btn_extra_small btn_info'"
      @click.native="modals.notice = true"
      >Enable Reorder</base-button
    >
    <!-- small modal -->
    <modal
      :show.sync="modals.notice"
      headerClasses="justify-content-center"
      type="notice"
    >
      <div slot="header">
        <h3>Enable Replacement Item Reorder</h3>
      </div>
      <div class="container text-center">
        <p>ARE YOU SURE YOU WANT TO ENABLE THIS ON REPLACEMENT ITEMS ?</p>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="modals.notice = false"
          >
            Close
          </base-button>
          <base-button
            :disabled="isReadOnly || isPartnerAccount"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="confirm"
          >
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import Util from "@/util/util";

export default {
  name: "replacement-item-reorder-enable",
  props: ["isReadOnly"],
  data() {
    return {
      modals: {
        notice: false,
      },
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  computed: {
    ...mapGetters({
      replacementItems: "replacementItem/replacementItems",
      isPartnerAccount: "authentication/isPartnerAccount",
      orderMetadata: "orderMetadata/orderMetadata"
    }),
    isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
  },
  methods: {
    ...mapActions({
      getReplacementItems: "replacementItem/getReplacementItems",
      updateLineItems: "lineItem/updateLineItems",
    }),
    setItemNumber(item) {
      let ctx = this;
      //get the current postion
      // the add 1 to convert from an index value to an acual number that makes sense to user
      item.itemNumber = ctx.replacementItems.findIndex((i) => { return i.lineItemId === item.lineItemId; });
      item.itemNumber++;

      return { lineItemId: item.lineItemId, itemNumber: item.itemNumber };
    },
    confirm(e) {
      let ctx = this;
      ctx
        .updateLineItems(ctx.replacementItems.map((i) => ctx.setItemNumber(i)))
        .then((response) => {
          ctx.getReplacementItems(ctx.$route.params.id);
          ctx.modals.notice = false;
        });
    },
  },
};
</script>
